/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { LakeUser } from './lakeUser';

export interface ReportMetadata {
  id?: number;
  requestTime?: string;
  startTimestamp?: string;
  endTimestamp?: string;
  reportType?: ReportMetadata.ReportTypeEnum;
  status?: ReportMetadata.StatusEnum;
  userId?: number;
  user?: LakeUser;
  accountId?: number;
  account?: Account;
  params?: string;
  resultLocation?: string;
  fileLength?: number;
}
export namespace ReportMetadata {
  export const ReportTypeEnum = {
    BoAdminOrders: 'BO_ADMIN_ORDERS',
    ClientOrders: 'CLIENT_ORDERS',
    TransactionLog: 'TRANSACTION_LOG',
    SystemLog: 'SYSTEM_LOG',
    Transfers: 'TRANSFERS',
    MichiganTransfers: 'MICHIGAN_TRANSFERS',
    LpTrades: 'LP_TRADES',
    ComprehensiveCsv: 'COMPREHENSIVE_CSV',
    ComprehensivePdf: 'COMPREHENSIVE_PDF',
    AnalyticsCurveCsv: 'ANALYTICS_CURVE_CSV',
    Rfq: 'RFQ',
    ClientBalanceCsv: 'CLIENT_BALANCE_CSV',
    ClientBalancePdf: 'CLIENT_BALANCE_PDF',
    ZeroHashClobExternalTrade: 'ZERO_HASH_CLOB_EXTERNAL_TRADE',
    Accounts: 'ACCOUNTS',
    BookHistory: 'BOOK_HISTORY',
    TopOfBookHistory: 'TOP_OF_BOOK_HISTORY',
    TsoeFixEvents: 'TSOE_FIX_EVENTS',
    SpotPositionHistory: 'SPOT_POSITION_HISTORY',
    PerpPositionHistory: 'PERP_POSITION_HISTORY',
    UserSession: 'USER_SESSION',
    ExternalTrade: 'EXTERNAL_TRADE',
    GoldenTransfer: 'GOLDEN_TRANSFER',
    AccountUnRealizedPnl: 'ACCOUNT_UN_REALIZED_PNL',
    HouseLpTrade: 'HOUSE_LP_TRADE',
  } as const;
  export type ReportTypeEnum = (typeof ReportTypeEnum)[keyof typeof ReportTypeEnum];
  export const StatusEnum = {
    Queued: 'QUEUED',
    InProgress: 'IN_PROGRESS',
    Done: 'DONE',
    Failed: 'FAILED',
    Cancelling: 'CANCELLING',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
